import React from 'react';

import { Slide } from '../../domain/Slide';
import { Video } from '../../domain/Video';

import { ThumbnailImageSlide } from './ThumbnailImageSlide';
import { ThumbnailMediaSlideProps } from './ThumbnailMediaSlideProps';
import { ThumbnailVideoSlide } from './ThumbnailVideoSlide';

export function buildThumbnailSlide(
  slide: Slide,
  onClickHandler: (index: number) => void
): React.ReactNode {
  const slideProps: ThumbnailMediaSlideProps = {
    slide,
    onClickHandler,
  };

  if (slide.media instanceof Video) {
    return <ThumbnailVideoSlide key={slide.thumbnailId} {...slideProps} />;
  }

  return ThumbnailImageSlide(slideProps);
}
